export const classificationTour = {
    module: 'classification',
    title: 'Classification Tour',
    title_vi: 'Tour Phân loại',
    description: 'As the Data Steward (P-VN-05), define data classification taxonomies, assign sensitivity labels, enforce retention policies, and resolve coverage gaps required for PDPL compliance.',
    description_vi: "Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Data Steward (P-VN-05), define data classification taxonomies, assign sensitivity labels, enforce retention policies, and resolve coverage gaps required for PDPL compliance.',",
    estimated_duration_seconds: 52,
    steps: [
        {
            step_id: 'open_classification',
            navigate_to: '/admin/classification/taxonomies',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Data Classification Module',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Data Classification Module',
            description: 'As the Data Steward, you define and enforce data sensitivity classifications here. Unlike Discovery (which finds data), this module labels it, applies retention policies, and identifies coverage gaps. PDPL distinguishes sensitive personal data requiring explicit consent.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Data Steward, you define and enforce data sensitivity classifications here. Unlike Discovery (which finds data), this module labels it, applies retention policies, and identifies coverage gaps. PDPL distinguishes sensitive personal data requiring explicit consent.',
            position: 'bottom',
        },
        {
            step_id: 'taxonomies_list',
            target: '.dm-table',
            title: 'Classification Taxonomies',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Classification Taxonomies',
            description: 'Taxonomies define sensitivity levels aligned with PDPL categories: personal data, sensitive personal data (health, biometrics, political opinions), and public data. Each taxonomy is versioned for audit traceability.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Taxonomies define sensitivity levels aligned with PDPL categories: personal data, sensitive personal data (health, biometrics, political opinions), and public data. Each taxonomy is versioned for audit traceability.',
            position: 'bottom',
        },
        {
            step_id: 'create_taxonomy',
            target: '.dm-header .btn-primary',
            title: 'Create a Taxonomy',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Create a Taxonomy',
            description: 'Define a new taxonomy aligned with your PDPL data classification requirements. Taxonomies drive which consent and protection levels apply.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Define a new taxonomy aligned with your PDPL data classification requirements. Taxonomies drive which consent and protection levels apply.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 300,
        },
        {
            step_id: 'fill_taxonomy_name',
            target: '[data-testid="taxonomy-name"]',
            wait_for: '[data-testid="taxonomy-name"]',
            title: 'Name the Taxonomy',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Name the Taxonomy',
            description: 'Use a descriptive name reflecting the data domain, such as "PDPL Sensitive Data Levels" or "Financial PII Classification".',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Use a descriptive name reflecting the data domain, such as "PDPL Sensitive Data Levels" or "Financial PII Classification".',
            position: 'bottom',
            action: {
                type: 'fill',
                target: '[data-testid="taxonomy-name"]',
                value: '[TOUR] PII Sensitivity Levels',
            },
        },
        {
            step_id: 'fill_taxonomy_description',
            target: '[data-testid="taxonomy-description"]',
            title: 'Add a Description',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Add a Description',
            description: 'Describe the taxonomy scope so data stewards know when to apply it. Reference the relevant PDPL data categories this taxonomy covers.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Describe the taxonomy scope so data stewards know when to apply it. Reference the relevant PDPL data categories this taxonomy covers.',
            position: 'bottom',
            action: {
                type: 'fill',
                target: '[data-testid="taxonomy-description"]',
                value: '[TOUR] Classification scheme for personally identifiable information across all data stores.',
            },
        },
        {
            step_id: 'taxonomy_submit',
            target: '.dm-form-actions button[type="submit"]',
            title: 'Save the Taxonomy',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Save the Taxonomy',
            description: 'Save the taxonomy as a draft. Add classification levels, then activate it. Labels assigned under this taxonomy feed into ROPA entries and DPIA risk assessments.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Save the taxonomy as a draft. Add classification levels, then activate it. Labels assigned under this taxonomy feed into ROPA entries and DPIA risk assessments.',
            position: 'top',
        },
        {
            step_id: 'labeling_rules',
            navigate_to: '/admin/classification/labeling',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Label Approval & Assignment',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Label Approval & Assignment',
            description: 'As the Data Steward, you assign and approve classification labels on data assets. Each label determines the PDPL protection level required. Bulk-reassignment supports large-scale reclassification campaigns.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Data Steward, you assign and approve classification labels on data assets. Each label determines the PDPL protection level required. Bulk-reassignment supports large-scale reclassification campaigns.',
            position: 'bottom',
        },
        {
            step_id: 'create_label',
            target: '.dm-header button',
            title: 'Assign a Label',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Assign a Label',
            description: 'Apply a classification label to a data asset. Unlabeled assets appear as coverage gaps in the gap analysis.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Apply a classification label to a data asset. Unlabeled assets appear as coverage gaps in the gap analysis.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header button' },
            duration_ms: 300,
        },
        {
            step_id: 'label_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Label Assignment Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Label Assignment Form',
            description: 'Select the data asset, taxonomy, and classification level. The rationale field documents why this sensitivity level was chosen, creating an audit trail for PDPL classification decisions.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Select the data asset, taxonomy, and classification level. The rationale field documents why this sensitivity level was chosen, creating an audit trail for PDPL classification decisions.',
            position: 'right',
        },
        {
            step_id: 'label_submit',
            target: '.dm-form-actions button[type="submit"]',
            title: 'Save the Label',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Save the Label',
            description: 'Apply the label. Periodic review resets the stale indicator. Stale labels represent potential PDPL compliance risks if data sensitivity has changed.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Apply the label. Periodic review resets the stale indicator. Stale labels represent potential PDPL compliance risks if data sensitivity has changed.',
            position: 'top',
        },
        {
            step_id: 'lifecycle_policies',
            navigate_to: '/admin/classification/lifecycle',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Lifecycle Policies',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Lifecycle Policies',
            description: 'Enforce PDPL retention and disposal obligations. Each record tracks the asset lifecycle stage, retention period, and legal basis for retention. Data must be deleted when the retention period expires or the processing purpose is fulfilled.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Enforce PDPL retention and disposal obligations. Each record tracks the asset lifecycle stage, retention period, and legal basis for retention. Data must be deleted when the retention period expires or the processing purpose is fulfilled.',
            position: 'bottom',
        },
        {
            step_id: 'create_lifecycle',
            target: '.dm-header button',
            title: 'Create a Lifecycle Record',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Create a Lifecycle Record',
            description: 'Assign a retention and disposal policy to a data asset. Assets without lifecycle records are flagged as PDPL compliance gaps.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Assign a retention and disposal policy to a data asset. Assets without lifecycle records are flagged as PDPL compliance gaps.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header button' },
            duration_ms: 300,
        },
        {
            step_id: 'lifecycle_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Lifecycle Record Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Lifecycle Record Form',
            description: 'Set the retention period, legal basis for retention, and deletion method. PDPL requires documented justification for retention and secure deletion when the purpose expires.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Set the retention period, legal basis for retention, and deletion method. PDPL requires documented justification for retention and secure deletion when the purpose expires.',
            position: 'right',
        },
        {
            step_id: 'coverage_gaps',
            navigate_to: '/admin/classification/gaps',
            wait_for: '.dm-page',
            target: '.dm-page',
            title: 'Coverage Gap Analysis',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Coverage Gap Analysis',
            description: 'Surfaces PDPL classification gaps: unlabeled assets, missing lifecycle records, stale labels, and expired retentions. Each gap must be remediated, acknowledged with ownership, or risk-accepted with written justification for audit purposes.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Surfaces PDPL classification gaps: unlabeled assets, missing lifecycle records, stale labels, and expired retentions. Each gap must be remediated, acknowledged with ownership, or risk-accepted with written justification for audit purposes.',
            position: 'bottom',
        },
        {
            step_id: 'gap_run_detection',
            target: '.dm-header button',
            title: 'Run Gap Detection',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Run Gap Detection',
            description: 'Scan all data assets to detect new classification gaps. This produces the gap inventory that the DPO reviews during compliance monitoring cycles.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Scan all data assets to detect new classification gaps. This produces the gap inventory that the DPO reviews during compliance monitoring cycles.',
            position: 'bottom',
        },
        {
            step_id: 'class_complete',
            target: '.dm-page',
            title: 'Classification Tour Complete',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Classification Tour Complete',
            description: 'You can now define PDPL-aligned classification taxonomies, assign and approve sensitivity labels, enforce retention policies, and resolve coverage gaps for audit readiness.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: You can now define PDPL-aligned classification taxonomies, assign and approve sensitivity labels, enforce retention policies, and resolve coverage gaps for audit readiness.',
            position: 'bottom',
        },
    ],
};
//# sourceMappingURL=classification.js.map